import { RSAA } from 'redux-api-middleware';

const prefixesExcludedFromAPI = ['/i18n/', 'http://', 'https://'];

const prepareEndpoint = (endpoint: string) => {
  if (prefixesExcludedFromAPI.some(prefix => endpoint.startsWith(prefix))) {
    return endpoint;
  }

  return process.env.REACT_APP_API_URL + endpoint;
};

export const endpointMiddleware = () => (next: any) => (action: any) => {
  const apiMiddleware = action[RSAA];

  if (!apiMiddleware) {
    return next(action);
  }

  return next({
    [RSAA]: {
      ...apiMiddleware,
      endpoint: prepareEndpoint(apiMiddleware.endpoint),
    },
  });
};
